import React from 'react'

const Admin: React.FC = () => {
  return <div></div>
}

export default Admin
